import { Button } from "@/components/ui/button/button";
import { useSupportChat } from "@/features/shared/support-chat";
import { PresaleSection } from "./presale-section";

export function PresaleHelp() {
  // Public page: a signed-out visitor was never identified, but `show()` boots
  // an anonymous session first — see `useSupportChat`.
  const { show: handleMessageUs } = useSupportChat();

  return (
    <PresaleSection title="We're here to help">
      <p className="mt-3 text-base leading-normal text-text-dark-high text-pretty">
        If you have any questions or concerns, or if your priorities change,
        don't hesitate to reach out. We're excited to get started and look
        forward to taking great care of your home.
      </p>
      <div className="mt-6">
        <Button size="xl" kind="soft" onClick={handleMessageUs}>
          Message us
        </Button>
      </div>
    </PresaleSection>
  );
}
